import { IFalconComponent, IFalconTheme } from '@se-admin/falcon';

export interface IDiscountBadge extends IFalconComponent {
  discountPrice: string;
  discountTooltip: string;
  variant: DiscountBadgeVariant;
  showTooltip?: boolean;
  theme?: IFalconTheme;
}

export enum DiscountBadgeVariant {
  urgent = 'urgent', // for the top left corner of sale card
  regular = 'regular', // where price is shown
  small = 'small', // small discount without border
}
